import * as types from './types';

function fetchingBrowserMeta() {
    return {
        type: types.FETCHING_BROWSER_META,
    };
}

function setBrowserMeta(data, meta, error) {
    return {
        type: types.SET_BROWSER_META,
        payload: data,
        meta,
        error,
    };
}

function setBrowserUserAgent(data) {
    return {
        type: types.SET_BROWSER_USER_AGENT,
        payload: data,
    };
}

function clearBrowserMeta() {
    return {
        type: types.CLEAR_BROWSER_META,
    };
}

export {
    clearBrowserMeta,
    fetchingBrowserMeta,
    setBrowserMeta,
    setBrowserUserAgent,
};
